exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2x9FSSiKI1aGHcmHpHlAAO{position:absolute;top:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;width:100%}html[dir] ._2x9FSSiKI1aGHcmHpHlAAO{text-align:center}html[dir=ltr] ._2x9FSSiKI1aGHcmHpHlAAO{left:0}html[dir=rtl] ._2x9FSSiKI1aGHcmHpHlAAO{right:0}._3OWsvwHlFC21OXEG24zh6Y{width:400px;font-size:17px;font-weight:300}", ""]);

// exports
exports.locals = {
	"messageContainer": "_2x9FSSiKI1aGHcmHpHlAAO",
	"messageText": "_3OWsvwHlFC21OXEG24zh6Y"
};